export function getHypotheticalFlowRates(maximumFlowRate: number): number[] {
  const unfilteredFlowRates = [
    ...[
      ...[...Array(4).keys()].map(v => (v + 1) * 10000 + 100000).reverse(),
      ...[...Array(10).keys()].map(v => (v + 1) * 10000).reverse(),
      ...[...Array(89).keys()].map(v => (v + 1) * 100 + 1000).reverse(),
      ...[...Array(90).keys()].map(v => (v + 1) * 10 + 100).reverse(),
      ...[...Array(100).keys()].map(v => (v + 1) * 1).reverse()
    ]
  ];
  const unusedFlowRates = unfilteredFlowRates.filter(
    hfr => hfr > maximumFlowRate
  );
  const usedFlowRates = unfilteredFlowRates.filter(
    hfr => hfr <= maximumFlowRate
  );
  const cielingFlowRate = unusedFlowRates.at(unusedFlowRates.length - 1);

  const retval = [Number(cielingFlowRate), ...usedFlowRates];
  return retval;
}
